import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, distinctUntilChanged, skip } from 'rxjs/operators';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrl: './filter.component.scss'
})
export class FilterComponent {

  @Input() statusOptions: any[] = [];
  @Input() searchBY: string = '';
  @Input() isOrder: boolean = false;
  @Input() isDateRange: boolean = true;
  @Input() planOptions: any[] = [];
  @Input() channelOptions: any[] = [];
  @Input() templateCodeOptions: any[] = [];
  @Input() filter: any = {
    search: true,
    dateRange: true,
    resetButton: true
  };

  @Output() filterChange = new EventEmitter<any>();

  searchControl = new FormControl('');
  orderControl = new FormControl('');

  selectedStatus: any = null;
  selectedPlan: any = null;
  rangeDates: Date[] | null = null;
  selectedTemplateCode: any = null;
  selectedChannel: any = '';
  maxDate: Date = new Date();

  private lastFilters: any;

  constructor(private activatedRoute: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.searchControl.valueChanges
      .pipe(
        skip(1),
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((val: any) => this.triggerSearch(val));

    this.orderControl.valueChanges
      .pipe(
        skip(1),
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe(() => this.emitFilters());

    this.activatedRoute.queryParams
      .pipe(
        distinctUntilChanged((prev, curr) => prev.status === curr.status)
      )
      .subscribe((query: any) => {
        this.selectedStatus = query.status || null;
        this.emitFilters();
      });
  }

  onSearchBlur() {
    this.triggerSearch(this.searchControl.value);
  }

  private triggerSearch(val: any) {
    if (val?.length > 2 || val?.length === 0) {
      this.emitFilters();
    }
  }

  emitFilters() {
    if (
      this.rangeDates &&
      this.rangeDates.length === 2 &&
      (!this.rangeDates[0] || !this.rangeDates[1])
    ) {
      return;
    }

    const filters = {
      search: this.searchControl.value,
      orderId: this.orderControl.value,
      status: this.selectedStatus,
      plan: this.selectedPlan,
      dateRange: this.rangeDates,
      templateCode: this.selectedTemplateCode,
      channel: this.selectedChannel
    };

    if (JSON.stringify(this.lastFilters) === JSON.stringify(filters)) {
      return;
    }

    this.lastFilters = filters;

    this.filterChange.emit(filters);
  }

  resetFilters() {
    if (this.searchControl) {
      this.searchControl.reset('');
    }

    if (this.orderControl) {
      this.orderControl.reset('');
    }
    this.selectedStatus = null;
    this.selectedPlan = null;
    this.rangeDates = null;
    this.selectedTemplateCode = null;
    this.selectedChannel = '';
    this.emitFilters();
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {},
      queryParamsHandling: ''
    });
  }
}